var map = {
	"./1.png": 67,
	"./2.png": 590,
	"./3.png": 827,
	"./4.png": 167,
	"./5.png": 554,
	"./6.png": 580,
	"./7.png": 737,
	"./8.png": 204,
	"./9.png": 606,
	"./Blue_Negative.png": 695,
	"./Blue_Neutral.png": 416,
	"./Blue_Positive.png": 887,
	"./Blue_Unknown.png": 894,
	"./Cauldron_Reset.png": 602,
	"./Green_Negative.png": 503,
	"./Green_Neutral.png": 111,
	"./Green_Positive.png": 512,
	"./Green_Unknown.png": 398,
	"./Neutral.png": 478,
	"./Red_Negative.png": 510,
	"./Red_Neutral.png": 3,
	"./Red_Positive.png": 465,
	"./Red_Unknown.png": 672,
	"./Temp_Down.png": 855,
	"./Temp_Up.png": 655,
	"./_.png": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 388;